import React, { useEffect, useState } from "react";
import DataTable from "../../../../Components/Others/DataTable";
import {
  CancelButton,
  CreateButton,
  FilterButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import { Link, useLocation } from "react-router-dom";
import SearchBar from "../../../../Components/Utils/SearchBar";
import UseGetData from "../../../../Components/Hooks/useFetchData";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import VehicleTable from "./VehicleTable";
import UseGetDataSearch from "../../../../Components/Hooks/useFetchDataBySearch";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import { useFormik } from "formik";
import * as yup from 'yup';
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import UseDropDown from "../../../../Components/Hooks/useDropDown";
import { GetAccess } from "../../../../Components/Utils/roles";
import useFetchMDIndex from "../../../../Components/Hooks/useFetchMDIndex";
import ViewToggle from "../../../../Components/Utils/ViewToggle";

function VehicleIndex() {
  const location = useLocation();
  const currentPage = location.state?.currentPage
  const searchQuery = location.state?.searchQuery
  const [page, setPage] = useState(currentPage || 1)
  const [pageCount, setPageCount] = useState(localStorage.getItem("perPageView") || 20)
  const [viewMode, setViewMode] = useState(localStorage.getItem("vehicleViewMode") || "table");
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 768 : false
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const effectiveViewMode = isMobile ? "card" : (viewMode === "list" ? "table" : viewMode);
  const [filter, setFilter] = useState(false);
  const [showFilterDialog, setShowFilterDialog] = useState(false);
  const { value: VehicleBrand } = useFetchMDIndex(`/dropdown/dropdown-details/`, 'VehicleBrand', showFilterDialog)
  const { value: VehicleType } = useFetchMDIndex(`/dropdown/dropdown-details/`, 'VehicleType', showFilterDialog)
  const { value: VehicleCondition } = useFetchMDIndex(`/dropdown/dropdown-details/`, 'VehicleCondition', showFilterDialog)
  const { value: VehicleStatus } = useFetchMDIndex(`/dropdown/dropdown-details/`, 'VehicleStatus', showFilterDialog)
  const { data: users } = UseDropDown("/user/drop-down");
  const { value: FuelType } = useFetchMDIndex(`/dropdown/dropdown-details/`, 'Vehicle_FuelType', showFilterDialog)


  const [filterProps, setFilterProps] = useState({
    status: "",
    assignedTo: "",
    condition: "",
    fuelType: "",
    brand: "",
    vehicleType: ""
  });
  const [params, setParams] = useState({
    page: page,
    per_page: pageCount,
    search: searchQuery || "",

    status: "",
    assignedTo: "",
    condition: "",
    fuelType: "",
    brand: "",
    vehicleType: ""
  });

  const clearFilter = () => {
    setParams({
      ...params, status: "",
      assignedTo: "",
      condition: "",
      fuelType: "",
      brand: "",
      vehicleType: ""
    })
    formik.values.status = ""
    formik.values.assignedTo = ""
    formik.values.condition = ""
    formik.values.fuelType = ""
    formik.values.brand = ""
    formik.values.vehicleType = ""

    setFilter(false)
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: filterProps,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      // email: yup.string().required('Email is required!'),
    }),
    onSubmit: async (value, { resetForm }) => {
      console.log("ffff", value);
      setParams({ ...params, status: value.status, assignedTo: value.assignedTo, condition: value.condition, fuelType: value.fuelType, brand: value.brand, vehicleType: value.vehicleType })
      closeFilterDialog();
      setFilter(true)
      setFilterProps({
        status: "",
        assignedTo: "",
        condition: "",
        fuelType: "",
        brand: "",
        vehicleType: ""
      });
    }
  })
  const { data, totalCount, getData, dataLoading } = UseGetDataSearch("/vehicles/", params);
  // console.log(data, "dddd");

  const defaultHeader = [
    {
      title: "ID",
      width: "5%",
      field: "vehicleId",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Vehicle Name",
      width: "9%",
      isLink: true,
      id: "vehicleId",
      link: '/maintenance/vehicle/view/',
      field: "name",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Assigned To ",
      width: "9%",
      field: "assignedToName",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Insurance Expiry",
      width: "9%",
      field: "moreDetails.insExpDate",
      type: "date",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Fahas Expiry ",
      width: "9%",
      field: "moreDetails.fahasExpDate",
      type: "date",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Istimara Expiry ",
      width: "9%",
      field: "moreDetails.istimaraExpDate",
      type: "date",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Condition",
      width: "9%",
      field: "condition",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Status",
      width: "9%",
      field: "status",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Action",
      width: "5%",
      field: "action",
      textAlign: "center",
      rowAlign: "center",
      contents: {
        // fetcher: getData,
        id: "vehicleId",
        removeValue: "Vehicles",
        url: "/vehicles/",
        moduleName: "vehicle",
        from: "/maintenance/vehicle",
        editLink: "/maintenance/vehicle/edit/",
        viewLink: "/maintenance/vehicle/view/",
      },
    },
  ];

  let availableHeaders = [
    {
      title: "ID",
      width: "5%",
      field: "vehicleId",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Vehicle Name",
      width: "9%",
      isLink: true,
      id: "vehicleId",
      link: '/maintenance/vehicle/view/',
      field: "name",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Type",
      width: "9%",
      field: "vehicleType",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Assigned To ",
      width: "9%",
      field: "assignedToName",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Brand",
      width: "9%",
      field: "brand",
      textAlign: "center",
      rowAlign: "center",
    },


    {
      title: "ChasisNo",
      width: "9%",
      field: "chasisNo",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Condition",
      width: "9%",
      field: "condition",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Fuel Type",
      width: "9%",
      field: "fuelType",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Plate No",
      width: "9%",
      field: "plateNo",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Purchased On",
      width: "9%",
      field: "purchasedOn",
      type: "date",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Insurance Date",
      width: "9%",
      field: "moreDetails.insDate",
      type: "date",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Insurance Expiry",
      width: "9%",
      field: "moreDetails.insExpDate",
      type: "date",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Insurance Company",
      width: "9%",
      field: "moreDetails.insCompany",
      textAlign: "center",
      rowAlign: "center",
    },

    {
      title: "Fahas Date",
      width: "9%",
      field: "moreDetails.fahasDate",
      type: "date",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Fahas Expiry ",
      width: "9%",
      field: "moreDetails.fahasExpDate",
      type: "date",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Istimara Expiry Date",
      width: "9%",
      field: "moreDetails.istimaraExpDate",
      type: "date",
      textAlign: "center",
      rowAlign: "center",
    },

    {
      title: "Status",
      width: "9%",
      field: "status",
      textAlign: "center",
      rowAlign: "center",
    },
    // {
    //   title: "Comments",
    //   width: "9%",
    //   field: "comments",
    //   textAlign: "center",
    //   rowAlign: "center",
    // },

    {
      title: "Action",
      width: "5%",
      field: "action",
      textAlign: "center",
      rowAlign: "center",
      contents: {
        // fetcher: getData,
        id: "vehicleId",
        removeValue: "Leads",
        url: "/vehicles/",
        moduleName: "vehicle",
        from: "/maintenance/vehicle",
        editLink: "/maintenance/vehicle/edit/",
        viewLink: "/maintenance/vehicle/view/",
      },
    },
  ];

  useEffect(() => {
    localStorage.setItem("vehicleViewMode", viewMode);
    setParams({ ...params, page: page, per_page: pageCount })
  }, [page, pageCount, viewMode])

  const closeFilterDialog = () => {
    setShowFilterDialog(false);
  };
  // return (
  return (
    <div className="w-full h-full px-2 sm:px-4 py-2">
      <div className="w-full flex flex-col md:flex-row justify-between items-stretch md:items-center gap-2 md:gap-3 mb-3">
        <div className="w-full md:w-auto flex justify-between items-center gap-2">
          <Breadcrumb
            items={[
              {
                name: "Maintenance",
              },
              {
                name: "Vehicle",
              },
            ]}
          />
          <div className="flex md:hidden items-center gap-2">
            <FilterButton handleClick={() => setShowFilterDialog(true)} />
            {filter && <FilterButton handleClick={() => clearFilter()} label="Clear" />}
            {GetAccess("vehicle_create") && (
              <Link to="/maintenance/vehicle/create/">
                <CreateButton label="Vehicle" />
              </Link>
            )}
          </div>
        </div>

        <div className="w-full md:w-auto flex flex-wrap md:flex-nowrap items-center gap-2">
          <div className="w-full md:w-fit">
            <SearchBar
              handleChange={(e) => {
                setParams({ ...params, search: e.target.value, page: 1 });
                setPage(1);
              }}
              value={params.search}
            />
          </div>
          <div className="hidden md:flex items-center gap-2">
            <FilterButton handleClick={() => setShowFilterDialog(true)} />
            {filter && <FilterButton handleClick={() => clearFilter()} label="Clear" />}
          </div>
          
          <ViewToggle
            viewMode={effectiveViewMode}
            onViewChange={(mode) => setViewMode(mode)}
            storageKey="vehicleViewMode"
          />

          <div className="hidden md:flex items-center gap-2">
            {GetAccess("vehicle_create") && (
              <Link to="/maintenance/vehicle/create/">
                <CreateButton label="Vehicle" />
              </Link>
            )}
          </div>
        </div>
      </div>

      <VehicleTable
        data={data}
        total={totalCount}
        pageIndex={page}
        setPageIndex={setPage}
        dataCount={pageCount}
        setDataCount={setPageCount}
        searchQuery={params?.search !== "" ? params?.search : ""}
        fetcher={getData}
        dataLoading={dataLoading}
        viewMode={effectiveViewMode}
      />
      {showFilterDialog && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center p-3 sm:p-4">
          <div className="animate-scale-in w-full sm:w-[480px] max-w-[95vw] max-h-[90vh] bg-white py-4 px-4 sm:px-6 rounded-xl shadow-lg overflow-y-auto">
            <h2 className="text-lg font-bold text-gray-800 mb-4">Filter Vehicle</h2>
            <form onSubmit={formik.handleSubmit}>
              <div className="flex flex-col gap-3 mb-4">
                <FormikSelectTwo
                  label="Vehicle Type"
                  placeholder="Choose"
                  formik={formik}
                  Options={VehicleType}
                  name="vehicleType"
                  width="w-full"
                />
                <FormikSelectTwo
                  label="Brand"
                  placeholder="Choose"
                  formik={formik}
                  Options={VehicleBrand}
                  name="brand"
                  width="w-full"
                />
                <FormikSelectTwo
                  label="Condition"
                  placeholder="Choose"
                  formik={formik}
                  Options={VehicleCondition}
                  name="condition"
                  width="w-full"
                />
                <FormikSelectTwo
                  type="text"
                  label="Assigned To"
                  placeholder="Assigned To"
                  Options={users}
                  formik={formik}
                  name="assignedTo"
                  width="w-full"
                />
                <FormikSelectTwo
                  label="Fuel Type"
                  placeholder="Fuel Type"
                  formik={formik}
                  Options={FuelType}
                  name="fuelType"
                  width="w-full"
                />
                <FormikSelectTwo
                  label="status"
                  placeholder="status"
                  formik={formik}
                  Options={VehicleStatus}
                  name="status"
                  width="w-full"
                />
              </div>
              <div className="flex justify-end gap-2 pt-2 border-t border-gray-100">
                <CancelButton handleClick={closeFilterDialog} />
                <SubmitButton name='Apply' />
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
export default VehicleIndex;
